import React from 'react'
import { graphql, StaticQuery } from 'gatsby'

import { JumbotronTemplate } from '../../../shared'

export default () => (
  <StaticQuery
    query={graphql`
      query FeaturedPostQuery {
        allMarkdownRemark(
          limit: 1
          sort: { order: DESC, fields: [frontmatter___date] }
          filter: {
            frontmatter: {
              templateKey: { eq: "blog-post" }
              featuredPost: { eq: true }
              popularPost: { eq: false }
              trendingPost: { eq: false }
              homepageHide: { eq: false }
            }
          }
        ) {
          edges {
            node {
              id
              fields {
                slug
              }
              frontmatter {
                title
                description
                featuredImage {
                  childImageSharp {
                    gatsbyImageData(width: 1000, quality: 100)
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => <JumbotronTemplate data={data} />}
  />
)
